import React, { FunctionComponent } from 'react';

import { Button } from './chroma';

interface AddButtonProps {
  onClick: () => void;
}

export const AddButton: FunctionComponent<AddButtonProps> = ({
  onClick,
  children,
}) => (
  <Button secondary size="lg" maxWidth onClick={onClick}>
    {children}
  </Button>
);

export default AddButton;
